import { render } from "./App.vue?vue&type=template&id=fb0f7fd8&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fb0f7fd8&lang=scss"
import "./App.vue?vue&type=style&index=1&id=fb0f7fd8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/ShelfDat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0f7fd8"]])

export default __exports__